<template>
  <div id="sac-button-select-container">
    <button
      v-for="(option, idx) in sacOptions"
      :key="idx"
      :class="[
        'sac-button-select',
        value === option.value ? 'active' : '',
      ]"
      @click="onSelect(option.value)"
    >
      {{ option.label }}
    </button>
    <slot
      v-if="showCustom"
      name="custom"
    />
  </div>
</template>

<script>
export default {
  name: 'SACButtonSelect',
  props: {
    value: [String, Number, Boolean],
    options: Array,
    onSelect: Function,
  },
  data() {
    const sacOptions = this.options.filter((o) => o.show);
    return {
      showCustom: this.value === 'custom',
      sacOptions,
    };
  },
  watch: {
    value(value) {
      if (value === 'custom') {
        this.showCustom = true;
      } else {
        setTimeout(() => {
          this.showCustom = false;
        }, 200);
      }
    },
  },
};
</script>

<style lang="scss">

#sac-button-select-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .sac-button-select {
    padding: 11px 16px 9px 16px;
    background-color: $NBLUE20;
    font-size: 0.875rem;
    font-weight: 600;
    border-radius: 33px;
    margin-bottom: 8px;
    &:hover {
      background-color: $NBLUE10;
    }
    &.active {
      background-color: $N100;
      color: $WHITE;
    }
    &:not(:last-child) {
      margin-right: 10px
    }
  }
}
</style>
